import React, { Component } from 'react';
import {
    BrowserRouter,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import { connect } from "react-redux";

import logo from './logo.svg';
import './App.css';
import ForgetPassword from './containers/forgetPassword';
import RecoverPassword from './containers/signin/recoverPassword';
import Signin from './containers/signin';
import MFA from './containers/mfa';
import Loading from './components/feedback/loading/index';
import CustomizedAlert from "./components/feedback/customizedAlert/index";
import Service from './containers/service';
import Logout from './containers/logout';
import ChangePassword from './containers/changePassword';
import { withMultiLanguagesProvider } from './contexts/messages';

class App extends Component {
  constructor(props) {
    super(props)
  }
  
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Loading></Loading>
          <CustomizedAlert></CustomizedAlert>
          <Switch>
            <Route path="/changepassword" component={ChangePassword} />
            <Route path="/forgetpassword" component={ForgetPassword} />
            <Route path="/recoverPassword" component={RecoverPassword} />
            <Route path="/login" component={Signin} />
            <Route path="/mfa" component={MFA} />
            <Route path="/startFrom" component={Service} />
            <Route path="/logout" component={Logout} />
            <Route exact path="/">
              <Redirect to={`/login${window.location.search}`}/>
            </Route>
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withMultiLanguagesProvider(App);
